import React from "react";
import tw from "tailwind-styled-components";
import { Formik, Field, Form } from "formik";
import Loading from "../Loading";
import {
  InputGroup,
  FieldWrapper,
  Label,
  SubmitBtn,
  CombineInputGroup,
} from "../Styles/InputStyles";
import { useSelector } from "react-redux";
import Model from "../Model";

const EditStockModel = ({
  editAddUser,
  editEntryLoading,
  setEditUser,
  selectedData,
}) => {
  const user = useSelector((state) => state.UserReducer.user);
  const gender = [
    { value: "1", label: "Male" },
    { value: "2", label: "Female" },
  ];
  const InitialValues = {
    source: selectedData?.source,
    gradea: selectedData?.quantityRecivedGradeA,
    gradeb: selectedData?.quantityRecivedGradeB,
    gradec: selectedData?.quantityRecivedGradeC,
    graded: selectedData?.quantityRecivedGradeD,

    quantityissuedGradeA: selectedData?.quantityissuedGradeA,
    quantityissuedGradeB: selectedData?.quantityissuedGradeB,
    quantityissuedGradec: selectedData?.quantityissuedGradeC,
    quantityissuedGraded: selectedData?.quantityissuedGradeD,

    destination: selectedData?.destination,
    balance: selectedData?.balance,
    balanceb: selectedData?.balanceb,
    balancec: selectedData?.balancec,
    balanced: selectedData?.balanced,

    id: selectedData?.id,
    cropType: selectedData?.cropType,
    cropName: selectedData?.cropName,
    recvdate: selectedData?.receivingDate,
    issueddate: selectedData?.issuedate,
  };




  const SubmitHandler = (values) => editAddUser(values);


  return (
    <Model width={`w-11/12 max-w-3xl`} setOpenModel={setEditUser}>
      <Title>Edit Stock Management </Title>

      {editEntryLoading && <Loading />}

      {!editEntryLoading && (
        <Formik initialValues={InitialValues} onSubmit={SubmitHandler}>
          <Form>
            <Wrapper>
              <InputGroup>
                <Label htmlFor="cropType" >Crop Type</Label>
                <FieldWrapper>
                  <Field name="cropName" id="cropType" type="text" autoComplete="off" required disabled />
                </FieldWrapper>
              </InputGroup>
              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="gradea">Quantity Received Grade A(kg)</Label>
                  <FieldWrapper>
                    <Field
                      type="number"
                      name="gradea"
                      id="gradea"
                      autoComplete="off"
                      className="truncate"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>

                <InputGroup>
                  <Label htmlFor="gradeb">Quantity Received Grade B(kg)</Label>
                  <FieldWrapper>
                    <Field
                      type="number"
                      name="gradeb"
                      id="gradeb"
                      autoComplete="off"
                      className="truncate"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>
                {user.companyName == "Kimolo Super Rice Ltd" && (
                  <>
                    <InputGroup>
                      <Label htmlFor="gradec">Quantity Received Grade C(kg)</Label>
                      <FieldWrapper>
                        <Field
                          type="number"
                          name="gradec"
                          id="gradec"
                          autoComplete="off"
                          className="truncate"
                          required
                        />
                      </FieldWrapper>
                    </InputGroup>

                    <InputGroup>
                      <Label htmlFor="graded">Quantity Received Grade D(kg)</Label>
                      <FieldWrapper>
                        <Field
                          type="number"
                          name="graded"
                          id="graded"
                          autoComplete="off"
                          className="truncate"
                          required
                        />
                      </FieldWrapper>
                    </InputGroup>


                  </>)}
              </CombineInputGroup>

              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="recvdate">Receiving Date</Label>
                  <FieldWrapper>
                    <Field
                      type="date"
                      name="recvdate"
                      id="recvdate"
                      autoComplete="off"
                      className="truncate"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>
                <InputGroup>
                  <Label htmlFor="source">Source</Label>
                  <FieldWrapper>
                    <Field name="source" id="source" type="text" autoComplete="off" required />
                  </FieldWrapper>
                </InputGroup>
              </CombineInputGroup>


              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="quantityissuedGradeA">Quantity Issued Grade A(kg)</Label>
                  <FieldWrapper>
                    <Field
                      type="number"
                      name="quantityissuedGradeA"
                      id="quantityissuedGradeA"
                      autoComplete="off"
                      className="truncate"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>

                <InputGroup>
                  <Label htmlFor="quantityissuedGradeB">Quantity Issued Grade B(kg)</Label>
                  <FieldWrapper>
                    <Field
                      type="number"
                      name="quantityissuedGradeB"
                      id="quantityissuedGradeB"
                      autoComplete="off"
                      className="truncate"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>
                {user.companyName == "Kimolo Super Rice Ltd" && (
                  <>
                    <InputGroup>
                      <Label htmlFor="quantityissuedGradec">Quantity Issued Grade C(kg)</Label>
                      <FieldWrapper>
                        <Field
                          type="number"
                          name="quantityissuedGradec"
                          id="quantityissuedGradec"
                          autoComplete="off"
                          className="truncate"
                          required
                        />
                      </FieldWrapper>
                    </InputGroup>

                    <InputGroup>
                      <Label htmlFor="quantityissuedGraded">Quantity Issued Grade D(kg)</Label>
                      <FieldWrapper>
                        <Field
                          type="number"
                          name="quantityissuedGraded"
                          id="quantityissuedGraded"
                          autoComplete="off"
                          className="truncate"
                          required
                        />
                      </FieldWrapper>
                    </InputGroup>




                  </>)}
              </CombineInputGroup>


              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="balance">Balance Quantity Grade A (kg)</Label>
                  <FieldWrapper>
                    <Field
                      type="number"
                      name="balance"
                      id="balance"
                      autoComplete="off"
                      className="truncate"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>

                <InputGroup>
                  <Label htmlFor="balanceb">Balance Quantity Grade B (kg)</Label>
                  <FieldWrapper>
                    <Field
                      type="number"
                      name="balanceb"
                      id="balanceb"
                      autoComplete="off"
                      className="truncate"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>
                {user.companyName == "Kimolo Super Rice Ltd" && (
                  <>
                    <InputGroup>
                      <Label htmlFor="balancec">Balance Quantity Grade C(kg)</Label>
                      <FieldWrapper>
                        <Field
                          type="number"
                          name="balancec"
                          id="balancec"
                          autoComplete="off"
                          className="truncate"
                          required
                        />
                      </FieldWrapper>
                    </InputGroup>

                    <InputGroup>
                      <Label htmlFor="balanced">Balance Quantity Grade D(kg)</Label>
                      <FieldWrapper>
                        <Field
                          type="number"
                          name="balanced"
                          id="balanced"
                          autoComplete="off"
                          className="truncate"
                          required
                        />
                      </FieldWrapper>
                    </InputGroup>



                  </>)}

              </CombineInputGroup>
              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="destination" >Destination</Label>
                  <FieldWrapper>
                    <Field name="destination" id="destination" type="text" autoComplete="off" required />
                  </FieldWrapper>
                </InputGroup>
                <InputGroup>
                  <Label htmlFor="issueddate">Issued Date</Label>
                  <FieldWrapper>
                    <Field
                      type="date"
                      name="issueddate"
                      id="issueddate"
                      autoComplete="off"
                      className="truncate"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>
              </CombineInputGroup>


            </Wrapper>
            <BtnWrapper>
              <SubmitBtn type="submit">Update</SubmitBtn>
            </BtnWrapper>
          </Form>
        </Formik>
      )}
    </Model>
  );
};

const Wrapper = tw.div`
grid gap-6 my-6 px-1 `;

const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const BtnWrapper = tw.div` w-full flex items-center justify-center space-x-10 mt-8`;

export default EditStockModel;
